import React from 'react';
import { AedStore } from './aed-store';

export const AedContext = React.createContext<AedStore | undefined>(undefined);
